module.exports = __webpack_public_path__ + "img/VPC-innovation.b9751f6.jpg";